export const prepareCustomerAreaUser = (
  area?: number,
  user?: number,
  roles?: number[]
): MutationBody => ({
  data: {
    type: 'CustomersAreasUsers',
    attributes: {},
    relationships: {
      ...(area
        ? {
            area: {
              data: {
                id: `/api/v2/customers-areas/${area}`,
                type: 'CustomersAreas'
              }
            }
          }
        : {}),
      ...(user
        ? {
            user: {
              data: { id: `/api/v2/customers-users/${user}`, type: 'CustomersUsers' }
            }
          }
        : {}),
      ...(roles
        ? {
            roles: roles.map((roleId) => ({
              id: `/api/v2/roles/${roleId}`,
              type: 'Role'
            }))
          }
        : {})
    }
  }
});
